import { getNetwork } from '../utils/getNetwork';
import { API_ROOT } from '../config';

const BASE = `${API_ROOT}/api/v1/roadway`;
const JSON_HEADERS = { headers: { 'Content-Type': 'application/json' } };

export const getRoadwaysApi = (pageNum = 0, recordCount = 999) =>
  getNetwork().get(`${BASE}/get/${pageNum}/${recordCount}`);

export const getRoadwayByIdApi = (id) =>
  getNetwork().post(`${BASE}/get/${id}`);

export const saveRoadwayApi = (payload) =>
  getNetwork().post(`${BASE}/save`, JSON.stringify(payload), JSON_HEADERS);

export const deleteRoadwayApi = (id) =>
  getNetwork().post(`${BASE}/delete/${id}`);

export const searchRoadwayByEventNameApi = (q) =>
  getNetwork().get(`${BASE}/searcheventname`, { params: { q } });

export const getRoadwayContractorsApi = () =>
  getNetwork().post(`${BASE}/contractor/all`);

export const getRoadwayWorkCategoriesApi = () =>
  getNetwork().post(`${BASE}/workcategory/all`);

export const getRoadwayEventNamesApi = () =>
  getNetwork().post(`${BASE}/eventname/all`);

export const getRoadwayRepairProgressesApi = () =>
  getNetwork().post(`${BASE}/repairprogress/all`);
